import Vue from 'vue'
import VueRouter from 'vue-router'
import Layouts from '@/views/layouts.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue')
  }, {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue')
  },
  {
    path: '/search/result',
    name: 'search',
    component: () => import('@/views/search/result.vue'),
  },
  {
    path: '/',
    name: 'Layouts',
    component: Layouts,
    children: [
      {
        path: "/index/index",
        name: "首页",
        component: () => import('@/views/index/index.vue')
      },
      {
        path: "/home",
        redirect: { path: "/index/index" }
      }, {
        path: "/index",
        redirect: { path: "/index/index" }
      }, {
        path: "/",
        redirect: { path: "/index/index" }
      }
    ]
  },
  {
    path: '/',
    name: 'Layouts',
    component: Layouts,
    children: [
      {
        path: "/admin/index",
        name: "人员管理",
        component: () => import('@/views/admin/index.vue')
      }, {
        path: "/admin/add",
        name: "添加管理员",
        component: () => import('@/views/admin/add.vue')
      }, {
        path: "/admin/update",
        name: "管理员修改",
        component: () => import('@/views/admin/update.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'Layouts',
    component: Layouts,
    children: [
      {
        path: "/means/index",
        name: "资产列表",
        component: () => import('@/views/means/index.vue'),
      },
      {
        path: "/means/add",
        name: "资产添加",
        component: () => import('@/views/means/save.vue'),
      },
      {
        path: '/means/update',
        name: '资产修改',
        component: () => import('@/views/means/save.vue'),
      }
    ],
  },
  {
    path: '/',
    name: 'Layouts',
    component: Layouts,
    children: [
      {
        path: "/mail/accounts/index",
        name: "授权帐号列表",
        component: () => import('@/views/mail/accounts/index.vue'),
      },
      {
        path: "/mail/accounts/save",
        name: "添加授权帐号",
        component: () => import('@/views/mail/accounts/save.vue'),
      }
    ],
  },
  {
    path: '/',
    name: 'Layouts',
    component: Layouts,
    children: [
      {
        path: "/mail/email/index",
        name: "邮件列表",
        component: () => import('@/views/mail/email/index.vue'),
      }
    ],
  },
  {
    path: '/',
    name: 'Layouts',
    component: Layouts,
    children: [
      {
        path: "/menu/index",
        name: "菜单列表",
        component: () => import('@/views/menu/index.vue')
      }, {
        path: "/menu/add",
        name: "菜单添加",
        component: () => import('@/views/menu/add.vue')
      }, {
        path: "/menu/update",
        name: "菜单修改",
        component: () => import('@/views/menu/update.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'Layouts',
    component: Layouts,
    children: [
      {
        path: "/permission/index",
        name: "权限列表",
        component: () => import('@/views/permission/index.vue')
      }, {
        path: "/permission/add",
        name: "权限添加",
        component: () => import('@/views/permission/add.vue')
      }, {
        path: "/permission/update",
        name: "权限修改",
        component: () => import('@/views/permission/update.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'Layouts',
    component: Layouts,
    children: [
      {
        path: "/log/index",
        name: "日志列表",
        component: () => import('@/views/log/index.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'Layouts',
    component: Layouts,
    children: [
      {
        path: '/daily/remind/index',
        name: '备忘录',
        component: () => import('@/views/daily/remind/index.vue'),
      },
      {
        path: '/daily/remind/save',
        name: '保存备忘录',
        component: () => import('@/views/daily/remind/save.vue'),
      }
    ],
  },
  {
    path: '/',
    name: 'Layouts',
    component: Layouts,
    children: [
      {
        path: '/daily/schedule/index',
        name: '日程管理',
        component: () => import('@/views/daily/schedule/index.vue'),
      },
      {
        path: '/daily/schedule/save',
        name: '保存日程',
        component: () => import('@/views/daily/schedule/save.vue'),
      },
      {
        path: '/daily/schedule/multi',
        name: '日程项',
        component: () => import('@/views/daily/schedule/multi.vue'),
      }
    ],
  },
  {
    path: '/',
    name: 'Layouts',
    component: Layouts,
    children: [
      {
        path: '/tools/product/index',
        name: '抢购助手',
        component: () => import('@/views/tools/product/index.vue'),
      },
      {
        path: '/tools/product/save',
        name: '保存商品信息',
        component: () => import('@/views/tools/product/save.vue'),
      },
      {
        path: '/tools/act/index',
        name: '抢购记录',
        component: () => import('@/views/tools/act/index.vue'),
      }
    ],
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router;

router.beforeEach((to, from, next) => {
  var _token = sessionStorage.getItem("token");
  if (to.path == "/login") {
    if (!_token) {
      next();
      return;
    }
    next("/index");
    return;
  }

  if (to.path == '/search/result') {
    next();
    return;
  }

  if (_token) {
    if (to.matched.length === 0) { //匹配前往的路由不存在
      from.name ? next({ name: from.name }) : next('/404'); //判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
    } else {
      next(); //如果匹配到正确跳转
    }
    return
  } else {
    next("/login");
    return
  }
})